var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSurvey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    baseProfile: "tiny",
    id: "Spec_icon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-240 16 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-113.1,98.1c9.9,0,17.9-8,17.9-17.9c0-9.9-8-17.9-17.9-17.9s-17.9,8-17.9,17.9 C-130.9,90.1-122.9,98.1-113.1,98.1z M-113.1,75.8c2.6,0,4.7,2.1,4.7,4.7c0,2.6-2.1,4.7-4.7,4.7c-2.6,0-4.7-2.1-4.7-4.7 C-117.8,77.9-115.7,75.8-113.1,75.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-125.8,143.8c9.1,2.6,18.8,2.4,27.9-0.3l-13.9-36L-125.8,143.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-139.6,190.2 -84.3,190.2 -88.8,178.6 -135.1,178.6 "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "-34.8,178.6 -53.6,178.6 -49.3,190.3 -41.4,190.2 -8.4,245.3 -215.5,245.3 -182.4,190.2 -174.2,190.2 -169.9,178.6 -189,178.6 -236,256.9 12.2,256.9 "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-168.1,204.8l-2.7,19.9l12.2-16l12.3-11.5l17.5-45.5c5.3,1.6,10.9,2.5,16.6,2.5c6,0,11.8-1,17.3-2.8l17.6,45.8l12.3,11.5 l12,15.6l-2.5-19.5l1.3-15.7l-20.5-55.7h11.4v9h5.5v-23.5h-5.5v9h-13.4l-13.3-37.3c1.4-3.2,2.2-6.7,2.2-10.4 c0-13.1-9.8-23.8-22.4-25.5l-0.2-21.6h-6.9l0.2,21.6c-12.6,1.7-22.4,12.4-22.4,25.5c0,5.3,1.6,10.1,4.3,14.2l-11.9,33.6h-13.9v-9 h-5.5v23.5h5.5v-9h11.9l-20.5,55.7L-168.1,204.8z M-125.8,143.8l14-36.4l13.9,36C-106.9,146.3-116.7,146.4-125.8,143.8z M-113.1,62.4c9.9,0,17.9,8,17.9,17.9c0,9.9-8,17.9-17.9,17.9s-17.9-8-17.9-17.9C-130.9,70.4-122.9,62.4-113.1,62.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-113.1,91.7c6.2,0,11.2-5,11.2-11.2s-5-11.2-11.2-11.2s-11.2,5-11.2,11.2S-119.3,91.7-113.1,91.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurvey);
export default __webpack_public_path__ + "static/media/survey.977e4a2ced0e1c099632e876e8a219e5.svg";
export { ForwardRef as ReactComponent };